export default __webpack_public_path__ + "static/img-cultura-2-8559e3cefe3e5f5330fc7055eae1890c.png";